import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    code: '',
    updated_id: '',
    lists: {},
    total_count: '',
    is_no_records: '',
    filter_list: {},
    filter_name: '',
    count: 1,
    list: {},
    Updatelist: {},
    search_criteria: '',
    message: {},
    error: '',
    details: '',
    tag_list: [],
    log_details: '',
    export: {},
    status_code: '',
    status_message: '',
    status_type: '',
    retainer_index_history:'',
    index_status:''

}
const mutations = {
    SET_DATAS(state, lists) {
        state.error = ''
        state.lists = lists.retainer_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.is_no_records = lists.is_no_records
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
    },
    LIST_DATA(state, list) {
        state.list = list
        state.error = ''
    },
    LIST_UPDATE_DATA(state, list) {
        state.Updatelist = list
        state.error = ''
    },
    EMAIL_RESULT(state, email_result) {
        state.email = email_result
        state.error = ''
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
        state.error = ''
    },
    ERROR_STATUS(state, code) {
        state.error = code
    },
    LIST_DETAILS(state, data) {
        state.details = data
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },
}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom

    }) {


        return AppService.retainer.getRetainers(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }  else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit("SET_DATAS", response.data.data); // getting all the list in the api call
                  } else {
                    commit("SET_CODE", response.data);
                  }
                  return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom

    }) {


        return AppService.retainer.getRetainersExport(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchRetainerInvoiceDetails({
        commit,
        rootState
    }) {
        return AppService.retainer.getRetainerInvoiceDetails(rootState.session.token)
            .then(response => {
                rootState.general.filterdetails = response.data
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.retainer.postRetainerInvoice(list, rootState.session.token)
            .then(response => {

                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit("SET_CODE", response.data);
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchList({
        commit,
        rootState
    }, id) {

        return AppService.retainer.getRetainerInvoice(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchviewList({
        commit,
        rootState
    }, id) {

        return AppService.retainer.getRetainerInvoiceView(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.retainer.postRetainerInvoiceUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit("SET_CODE", response.data);
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updatePayment({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.retainer.postRetainerPaymentUpdate(id, field, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit("SET_CODE", response.data);
                    rootState.payment.message = response.data.data
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateRefund({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.retainer.postRetainerRefundUpdate(id, field, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deleteRefund({
        commit,
        rootState
    }, id) {

        return AppService.retainer.postRetainerRefundDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deleteretainer({
        commit,
        rootState
    }, data) {

        return AppService.retainer.getRetainerDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.retainer.postFiltercreateRetainerInvoice(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.retainer.postFilterdeleteRetainerInvoice(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.retainer.postFilterudpateRetainerInvoice(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.retainer.postRetainerBulkDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_LOG', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchQuotDetails({
        commit,
        rootState
    }, id) {

        return AppService.retainer.getQuotationDetails(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }
                return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },


}
export default {
    namespaced,
    state,
    mutations,
    actions
}